module.exports = __webpack_public_path__ + "static/media/img_1.e3f49daa.png";